/** Shared by visible furniture and collision proxies; metres. */
export const CHAIR_SIZE = [0.46, 1, 0.46] as const;
export function chairOffsetZ(deskDepth: number): number { return deskDepth / 2 + 0.2; }

import type { Interactable } from '../types/scenario';
const SHARED_DESKS: Record<string, string> = {
  'int-pc-player': 'int-player-desk',
  'int-pc-soumu-01': 'int-omori-desk',
  'int-pc-keiri-01': 'int-keiri-desk',
  'int-pc-dev-01': 'int-dev-island',
  'int-pc-dev-02': 'int-dev-island',
  'int-pc-dev-03': 'int-dev-island',
  'int-pc-note-01': 'int-meeting-table',
};
/** Explicit room-specific desk ownership avoids a second desk intersecting the shared one. */
export function sharedDeskFor(item: Interactable, items: Interactable[]): Interactable | undefined {
  return items.find(other => other.id === SHARED_DESKS[item.id] && other.roomId === item.roomId && other.visual === 'desk');
}
export function sharedChairOffset(item: Interactable, desk: Interactable): number {
  return desk.position[2] + (desk.size?.[2] ?? 0.7) / 2 + 0.2 - item.position[2];
}
